import { Component, inject } from "@angular/core";
import { ConfirmationModalModel } from "./model/confirmation-modal-model";
import { Subject } from "rxjs";
import { BsModalRef } from "ngx-bootstrap/modal";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "common-confirmation-modal",
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: "./common-confirmation-modal.component.html",
  styleUrl: "./common-confirmation-modal.component.scss",
})
export class CommonConfirmationModalComponent {
  readonly #bsModalRef = inject(BsModalRef);
  model: ConfirmationModalModel | undefined;
  onButtonPressed: Subject<boolean> = new Subject<boolean>();

  positive() {
    this.onButtonPressed.next(true);
  }

  negative() {
    this.#bsModalRef.hide();
    this.onButtonPressed.next(false);
  }
}
